import * as types from "../actions/types";

const INITIAL_STATE = {
  globalSearchResults: null
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.FETCH_GLOBAL_SEARCH_RESULTS:
      return { ...state, globalSearchResults: action.payload };

    default:
      return state;
  }
}
